module.exports = __webpack_public_path__ + "img/folder.01fc1324.svg";